module.exports = __webpack_public_path__ + "static/media/f2.e03e686d.png";